import { Loader } from '@googlemaps/js-api-loader';

/**
 * Map
 * @param {Object} latLng
 */
export default function (latLng) {
    let mapStyles = [
        {
            featureType: 'administrative',
            elementType: 'labels.text.fill',
            stylers: [
                {
                    color: '#444444',
                },
            ],
        },
        {
            featureType: 'landscape',
            elementType: 'all',
            stylers: [
                {
                    color: '#f2f2f2',
                },
            ],
        },
        {
            featureType: 'poi',
            elementType: 'all',
            stylers: [
                {
                    visibility: 'off',
                },
            ],
        },
        {
            featureType: 'poi.business',
            elementType: 'geometry.fill',
            stylers: [
                {
                    visibility: 'on',
                },
            ],
        },
        {
            featureType: 'road',
            elementType: 'all',
            stylers: [
                {
                    saturation: -100,
                },
                {
                    lightness: 45,
                },
            ],
        },
        {
            featureType: 'road.highway',
            elementType: 'all',
            stylers: [
                {
                    visibility: 'simplified',
                },
            ],
        },
        {
            featureType: 'road.arterial',
            elementType: 'labels.icon',
            stylers: [
                {
                    visibility: 'off',
                },
            ],
        },
        {
            featureType: 'transit',
            elementType: 'all',
            stylers: [
                {
                    visibility: 'off',
                },
            ],
        },
        {
            featureType: 'water',
            elementType: 'all',
            stylers: [
                {
                    color: '#b4d4e1',
                },
                {
                    visibility: 'on',
                },
            ],
        },
    ];

    const loader = new Loader({
        apiKey: menaObject.mapKey,
    });

    loader.load().then(() => {
        let myLatLng = latLng;

        // Convert string to number
        let latCords = parseFloat(myLatLng.lat);
        let lngCords = parseFloat(myLatLng.lng);
        myLatLng = { lat: latCords, lng: lngCords };

        let bounds = new google.maps.LatLngBounds();
        let map = new google.maps.Map(document.getElementById('map'), {
            center: myLatLng,
            zoom: 11,
            styles: mapStyles,
            disableDefaultUI: true,
            zoomControl: false,
        });

        const beachMarker = new google.maps.Marker({
            position: myLatLng,
            map,
            icon: menaObject.pin,
        });
    });
}
